import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=15eae0a7"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=15eae0a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_66tmnsjmdpdsiqf6am2qinky4q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports